import type { EventSignupSlot, EventSignupSlotStatus, UpdateEventSignupSlotDto } from './celebration';

export const EVENT_LIST_PARTICIPATION_MODES = ['view', 'signup', 'contribute'] as const;
export type EventListParticipationMode = (typeof EVENT_LIST_PARTICIPATION_MODES)[number];

export const EVENT_LIST_TEMPLATE_KEYS = ['potluck', 'drinks', 'dj_playlist', 'volunteer_duties'] as const;
export type EventListTemplateKey = (typeof EVENT_LIST_TEMPLATE_KEYS)[number];

export interface EventListTemplate {
  key: EventListTemplateKey;
  name: string;
  description: string;
  participation_mode: EventListParticipationMode;
  default_category: string;
}

export const EVENT_LIST_TEMPLATES: readonly EventListTemplate[] = [
  {
    key: 'potluck',
    name: 'Potluck',
    description: 'Who is bringing which dish.',
    participation_mode: 'signup',
    default_category: 'dish',
  },
  {
    key: 'drinks',
    name: 'Drinks',
    description: 'Drinks guests can offer to bring.',
    participation_mode: 'signup',
    default_category: 'drinks',
  },
  {
    key: 'dj_playlist',
    name: 'DJ Playlist',
    description: 'Songs guests would like played at the party.',
    participation_mode: 'contribute',
    default_category: 'song',
  },
  {
    key: 'volunteer_duties',
    name: 'Volunteer Duties',
    description: 'Duties guests can sign up to help with.',
    participation_mode: 'signup',
    default_category: 'duty',
  },
] as const;

export interface EventList {
  id: number;
  event_id: number;
  name: string;
  description?: string | null;
  participation_mode: EventListParticipationMode;
  template_key?: string | null;
  sort_order: number;
  created_by: number;
  updated_by: number;
  created_at: string;
  updated_at: string;
  deleted_at?: string | null;
}

export type EventListItem = EventSignupSlot;

export interface EventListWithItems extends EventList {
  items: EventListItem[];
}

export interface CreateEventListDto {
  name: string;
  description?: string;
  participation_mode?: EventListParticipationMode;
  template_key?: string | null;
  sort_order?: number;
}

export interface UpdateEventListDto {
  name?: string;
  description?: string | null;
  participation_mode?: EventListParticipationMode;
  sort_order?: number;
}

export interface CreateEventListItemDto {
  title: string;
  category?: string;
  quantity?: number;
  cost_note?: string;
  sort_order?: number;
}

export type UpdateEventListItemDto = UpdateEventSignupSlotDto;

export interface GuestAddEventListItemDto {
  title: string;
  category?: string;
  quantity?: number;
  note?: string;
}

export type { EventSignupSlotStatus };
